import { GivelifyButton, GivelifyLabel } from '@givelify/givelify-ui';
import { styled } from '@mui/material';

export const ModalContainer = styled('div')(({ theme }) => ({
    textAlign: 'center',
    padding: theme.spacing(0, 5),
    [theme.breakpoints.down('mobile')]: {
        padding: theme.spacing(0, 2),
    },
    '& input': {
        background: '#fff',
        borderColor: '#adadad',
        padding: theme.spacing(2),
    },
}));

export const LoginTitle = styled(GivelifyLabel)(({ theme }) => ({
    color: '#4a4a4a',
    fontWeight: 'bold',
    textAlign: 'center',
    lineHeight: '26px',
    fontSize: 24,
    [theme.breakpoints.down('mobile')]: {
        fontSize: 18,
    },
}));

export const StyledButton = styled(GivelifyButton)(({ theme }) => ({
    paddingTop: 10,
    paddingBottom: 10,
    margin: '0px auto 48px auto',
    [theme.breakpoints.down('mobile')]: {
        width: '100%',
        marginBottom: 40,
    },
}));
